import React from 'react';
import { connect } from 'react-redux';

import Media from '@components/media/Media.tsx';
import scrollToBlock from '@functions/scrollToBlock.ts';
import setAsyncTimer from '@functions/setAsyncTimer.ts';
import { StoreT } from '@global/types.ts';

import RootI from './types.ts';

const Styles = typeof window !== 'undefined' && require('./components/Styles.tsx').default;

class Root extends React.Component<RootI['props'], RootI['state']> implements RootI {
    parent: RootI['parent'];
    titleIndex: RootI['titleIndex'];

    constructor(props: RootI['props']) {
        super(props);
        this.state = {
            titleIndex: -1,
            titleState: 'next',
        };

        this.parent = React.createRef();
    }

    titles = ['2026', 'Приходит', 'Твой', 'Счастливый', 'Любимый', 'Удачный', 'Новый', 'Год'];
    // titles = ['2026'];

    renderTitle() {
        return (
            <div className="index__headerTitle">
                {this.titles.map((title, tI) => (
                    <div className="index__headerTitleItem" key={title}>
                        {title.split('').map((char, i) => (
                            <div
                                className="index__headerTitleItemChar"
                                key={i}
                                data-key={tI}
                                // style={{ transitionDelay: `${i * 100}ms` }}
                            >
                                {char}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    async startTitles() {
        if (!this.parent.current) {
            return;
        }

        let titleIndex = this.titleIndex ?? -1;

        if (titleIndex >= this.titles.length - 1) {
            titleIndex = -1;

            await setAsyncTimer(500);
        }

        titleIndex += 1;

        this.titleIndex = titleIndex;

        const chars = this.parent.current!.querySelectorAll<HTMLElement>(
            `.index__headerTitleItemChar[data-key="${titleIndex}"]`,
        );

        chars.forEach((c) => {
            c.style.transform = `translate(150rem,0)`;
        });

        await setAsyncTimer(100);

        chars.forEach((c, i) => {
            c.style.transition = '.3s ease-out';
            c.style.transitionDelay = `${i * 50}ms`;
            c.style.transform = `translate(0,0)`;
            c.classList.add('_current');
        });

        await setAsyncTimer(1_500);

        chars.forEach((c, i) => {
            c.style.transition = '.3s ease-in';
            c.style.transitionDelay = `${i * 50}ms`;
            c.style.transform = `translate(-150rem,0)`;
            c.classList.remove('_current');
        });

        await setAsyncTimer(chars.length * 50 + 300);

        chars.forEach((c) => {
            c.style.transition = '';
            c.style.transitionDelay = '';
            c.style.transform = '';
        });

        this.startTitles();
    }

    scrollHandler() {
        const parentNode = this.parent.current!;

        if (!parentNode) {
            return;
        }

        const scrollTop = parentNode.scrollTop;
        const contentNode = parentNode.querySelector('.index__content') as HTMLElement;
        const backNode = parentNode.querySelector('.index__headerBack') as HTMLElement;

        const top = scrollTop / 5;

        contentNode.style.marginTop = `${-top}px`;
        backNode.style.transform = `scale(${1 + scrollTop / 5000})`;
    }

    componentDidMount(): void {
        const name =
            document.querySelector('[data-giftName]')?.getAttribute('data-giftName') || undefined;
        const giftLink =
            document.querySelector('[data-giftLink]')?.getAttribute('data-giftLink') || undefined;

        this.setState({ name, giftLink });

        this.startTitles();
    }

    render() {
        const { name, giftLink } = this.state;

        return (
            <>
                {Styles && <Styles />}
                <div
                    ref={this.parent}
                    className="body__content _NOSCROLL"
                    onScroll={this.scrollHandler.bind(this)}
                >
                    <div className="index">
                        <div className="index__header">
                            <img
                                src={require('@media/logo.svg').default}
                                alt=""
                                className="index__headerLogo"
                            />
                            <Media current="desktop">
                                <video
                                    src={require('@media/back-video.mp4')}
                                    className="index__headerBack"
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                />
                            </Media>
                            <Media current="mobile">
                                <video
                                    src={require('@media/back-video-mob.mp4')}
                                    className="index__headerBack"
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                />
                            </Media>
                            <div className="index__headerContent">
                                {this.renderTitle()}
                                <Media current="desktop">
                                    <div
                                        className="index__headerButton"
                                        onClick={() => {
                                            scrollToBlock({
                                                blockNode: this.parent.current!.querySelector(
                                                    '.index__content',
                                                ) as HTMLElement,
                                                scrollNode: this.parent.current!,
                                                duration: 500,
                                                dir: 'top',
                                            });
                                        }}
                                    >
                                        Гоу, за подарком...
                                    </div>
                                </Media>
                            </div>
                        </div>
                        <div className="index__content">
                            <div className="index__contentInner">
                                <Media current="mobile">
                                    <div
                                        className="index__headerButton"
                                        onClick={() => {
                                            scrollToBlock({
                                                blockNode: this.parent.current!.querySelector(
                                                    '.index__content',
                                                ) as HTMLElement,
                                                scrollNode: this.parent.current!,
                                                duration: 500,
                                                dir: 'top',
                                            });
                                        }}
                                    >
                                        Гоу, за подарком...
                                    </div>
                                </Media>
                                <img
                                    src={require('@media/arrow.svg').default}
                                    alt=""
                                    className="index__contentArrow"
                                />
                                <h3 className="index__contentTitle">{name}, c Наступающим!</h3>
                                <p className="index__contentText">
                                    Наш милый юникорн 🦄 просил передать подарок 💝.
                                    Это&nbsp;универсальный подарочный сертификат, который можно
                                    обменять на любой такой же, но конкретный. Думаем, ты выберешь
                                    себе подарок по душе.
                                </p>
                                <div className="index__contentButtons">
                                    <a
                                        className="index__contentButton"
                                        href={giftLink || '#'}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span>Подарок</span>
                                    </a>
                                    <a
                                        className="index__contentButton _white"
                                        href="https://mygiftcard.ru/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span>Использовать здесь*</span>
                                    </a>
                                </div>
                                <p className="index__contentSubTitle">
                                    Удачи и счастливого <br className="_MOBILE" />
                                    Нового года!
                                </p>
                                <p className="index__contentSupport">Коллеги из Mage Digital</p>
                                <p className="index__contentInfo">
                                    * При нажатии на кнопку осуществляется переход на сайт
                                    mygiftcard.ru, <br />
                                    где можно произвести активацию универсального сертификата
                                </p>
                            </div>
                            <p className="index__contentCopy">© Mage Digital 2009-2026</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        rootInit: state.rootInit,
    };
}

export default connect(mapStateToProps)(Root);
